/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Dialog_Create_TitleInputs */

const en_branches_dialog_create_title = /** @type {(inputs: Branches_Dialog_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New branch`)
};

const pt_br2_branches_dialog_create_title = /** @type {(inputs: Branches_Dialog_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova filial`)
};

/**
* | output |
* | --- |
* | "New branch" |
*
* @param {Branches_Dialog_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_dialog_create_title = /** @type {((inputs?: Branches_Dialog_Create_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Dialog_Create_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_dialog_create_title(inputs)
	return pt_br2_branches_dialog_create_title(inputs)
});